<template>
    <BaseLayout>
        <Banner :block="$page.props.content_blocks.rent_your_car_block" />

        <div class="container py-5">
            <div class="col-lg-8 col-md-7 mx-auto">
                <NavTabs />
                <div class="shadow rounded-4 p-lg-5 p-3">
                    <form @submit.prevent="submit" class="vstack gap-4" autocomplete="off">
                        <div>
                            <div class="mb-3">
                                <h1 class="ff-dsb fs-26 text-primary">Car Details</h1>
                            </div>
                            <div class="row g-3">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="" class="form-label">Car Make <sup class="text-danger">*</sup></label>
                                        <div class="form-control" :class="{ 'is-invalid': errors.make }">
                                            <Multiselect v-model="enquiryForm.make" :searchable="true"
                                                :options="$page.props.makes" label="name" valueProp="id"
                                                @select="makesSelect" @clear="makesClear">
                                            </Multiselect>
                                        </div>
                                        <div v-if="errors.make" class="invalid-feedback">
                                            {{ errors.make }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="" class="form-label">Car Model <sup class="text-danger">*</sup></label>
                                        <div class="form-control" :class="{ 'is-invalid': errors.model }">
                                            <Multiselect v-model="enquiryForm.model" :options="models" label="name"
                                                valueProp="id"></Multiselect>
                                        </div>
                                        <div v-if="errors.model" class="invalid-feedback">
                                            {{ errors.model }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="" class="form-label">Manufacture Year <sup class="text-danger">*</sup></label>
                                        <input type="text" class="form-control" :class="{ 'is-invalid': errors.year }" @input="enquiryForm.year = $filters.validateNumberInput(enquiryForm.year)"
                                            v-model="enquiryForm.year">

                                        <div v-if="errors.year" class="invalid-feedback">
                                            {{ errors.year }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="" class="form-label">Mileage <sup class="text-danger">*</sup></label>
                                        <input type="text" class="form-control"
                                            :class="{ 'is-invalid': errors.mileage }" v-model="enquiryForm.mileage" @input="enquiryForm.mileage = $filters.validateNumberInput(enquiryForm.mileage)">

                                        <div v-if="errors.mileage" class="invalid-feedback">
                                            {{ errors.mileage }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="" class="form-label">Renting Period <sup class="text-danger">*</sup></label>
                                        <Flatpickr @data-from-child="handleDataFromChild" :mode="'range'"
                                            :class="{ 'is-invalid': errors.available_to_rent_from || errors.available_to_rent_to }" />

                                        <div v-if="errors.available_to_rent_from || errors.available_to_rent_to"
                                            class="invalid-feedback">
                                            {{ errors.available_to_rent_from ?? errors.available_to_rent_to }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label for="" class="form-label">Additional Details</label>
                                        <textarea name="" id="" class="form-control"
                                            :class="{ 'is-invalid': errors.additional_details }"
                                            v-model="enquiryForm.additional_details">{{ enquiryForm.additional_details }}</textarea>

                                        <div v-if="errors.additional_details" class="invalid-feedback">
                                            {{ errors.additional_details }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div class="mb-3">
                                <h1 class="ff-dsb fs-26 text-primary">Personal Details</h1>
                            </div>
                            <div class="row g-3">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="" class="form-label">Name <sup class="text-danger">*</sup></label>
                                        <input type="text" class="form-control" v-model="enquiryForm.customer_name"
                                            :class="{ 'is-invalid': errors.customer_name }">
                                        <div v-if="errors.customer_name" class="invalid-feedback">
                                            {{ errors.customer_name }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="" class="form-label">Email <sup class="text-danger">*</sup></label>
                                        <input type="text" class="form-control"
                                            :class="{ 'is-invalid': errors.customer_email }"
                                            v-model="enquiryForm.customer_email">
                                        <div v-if="errors.customer_email" class="invalid-feedback">
                                            {{ errors.customer_email }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="" class="form-label">Phone Number <sup class="text-danger">*</sup></label>
                                        <input type="text" class="form-control"
                                            :class="{ 'is-invalid': errors.customer_contact }" @input="enquiryForm.customer_contact = $filters.validateNumberInput(enquiryForm.customer_contact)"
                                            v-model="enquiryForm.customer_contact">

                                        <div v-if="errors.customer_contact" class="invalid-feedback">
                                            {{ errors.customer_contact }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label for="" class="form-label">State <sup class="text-danger">*</sup></label>
                                        <select id="select-model" :class="{ 'is-invalid': errors.state }"
                                            v-model="enquiryForm.state" class="form-control form-select">
                                            <option v-for="(value, key) in $page.props.locations" :value="key">{{ value
                                                }}
                                            </option>
                                        </select>

                                        <div v-if="errors.state" class="invalid-feedback">
                                            {{ errors.state }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-center">
                            <button class="btn btn-gradient-primary fs-15 px-5 py-3 rounded-4" type="submit" :disabled="enquiryForm.processing">
                                Submit <i v-if="enquiryForm.processing" class="fad fa-spinner-third fa-spin"></i>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </BaseLayout>
</template>

<script setup>
import { useForm, usePage } from '@inertiajs/vue3';
import { useReCaptcha } from 'vue-recaptcha-v3';
import BaseLayout from '../../../../../../resources/js/front/Layouts/BaseLayout.vue';
import Flatpickr from '../../../../../../resources/js/front/Components/Flatpickr.vue';
import Multiselect from '@vueform/multiselect';
import { ref } from 'vue';
import axios from 'axios';
import Banner from '../Components/Banner.vue';
import NavTabs from '../Components/NavTabs.vue';

const props = defineProps({ errors: Object })
const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()
const page = usePage();
const models = ref(page.props.models);

let selectedDate = ref('');

const handleDataFromChild = (data) => {
    selectedDate = data.value;  // Get data from child
};

const enquiryForm = useForm({
    make: null,
    model: null,
    year: null,
    mileage: null,
    renting_period: null,
    additional_details: null,
    customer_name: page.props.user ? page.props.user.name : null,
    customer_email: page.props.user ? page.props.user.email : null,
    customer_contact: page.props.user ? page.props.user.contact_no : null,
    state: null,
    g_recaptcha_response: null,
})

async function submit() {
    await recaptchaLoaded()
    enquiryForm.g_recaptcha_response = await executeRecaptcha('enquiry')
    enquiryForm.renting_period = selectedDate;
    enquiryForm.post(route('front.enquiry.rent-own-car'), {
        onSuccess: () => {
            if (!enquiryForm.hasErrors) {
                enquiryForm.reset()
                selectedDate = '';
            }
        },
    });
}

function makesSelect(id) {
    axios.post(route('front.get-models-with-id'), { make: id })
        .then((res) => {
            models.value = res.data
            enquiryForm.model = null;
        })
        .catch((err) => {
            console.log(err);
        })
}

function makesClear() {
    enquiryForm.model = null;
    models.value = null;
}
</script>

<style>
@import '../../../../../../node_modules/@vueform/multiselect/themes/default.css';
</style>
